module.exports = __webpack_public_path__ + "img/via-w.90a3cf68.svg";